import(/* webpackMode: "eager" */ "/codebuild/output/src2377537677/src/src/app/global-error.tsx");
